<header [class]="desktopHeaderClass">
    <img src="/assets/brand/gabali-logo.png" routerLink="/home" alt="Gabali Realty logo">
    <ul class="navbar-large">
        <li class="navbar-item">
            <div  class="dropdown">
                <span class="dropdown-button">
                    My Profile
                    <span class="down-arrow">
                        <app-icon name="expand_more" />
                    </span>
                </span>
                <div *ngIf="isLoggedIn$ | async" class="dropdown-content">
                    <a routerLink="/favorite-properties">Favorite List</a>
                    <a *ngIf="auth.isAdmin" routerLink="/admin" routerLinkActive="active">Admin</a>
                    <button type="button" class="dropdown-action" (click)="logout()">Log Out</button>
                </div>
                <div *ngIf="isLoggedOut$ | async" class="dropdown-content">
                    <button type="button" class="dropdown-action" (click)="openSignIn()">Sign In</button>
                    <button type="button" class="dropdown-action" (click)="openSignUp()">Sign Up</button>
                </div>
            </div>
        </li>
        <li class="navbar-item">
            <a
                routerLink="/featured-properties"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
            >
                For Sale
            </a>
        </li>
        <li class="navbar-item">
            <a
                routerLink="/for-rent"
                routerLinkActive="active"
            >
                For Rent
            </a>
        </li>
        <li class="navbar-item">
            <div class="dropdown">
                <span class="dropdown-button">
                    Buy
                    <span class="down-arrow">
                        <app-icon name="expand_more" />
                    </span>
                </span>
                <div class="dropdown-content">
                    <a routerLink="/featured-properties">Real Estate Search</a>
                    <a routerLink="/buyer-guide" routerLinkActive="active">Buyer's Guide</a>
                </div>
            </div>
        </li>
        <li class="navbar-item">
            <div class="dropdown">
                <span class="dropdown-button">
                    Sell
                    <span class="down-arrow">
                        <app-icon name="expand_more" />
                    </span>
                </span>
                <div class="dropdown-content">
                    <a routerLink="/home-estimate-page" routerLinkActive="active">What's My Home Worth?</a>
                    <a routerLink="/seller-guide" routerLinkActive="active">Seller's Guide</a>
                </div>
            </div>
        </li>   
        <li class="navbar-item">
            <a routerLink = "/agents" routerLinkActive="active">
                Agents
            </a>
        </li>
        <li class="navbar-item">
            <a routerLink="/contact-page" routerLinkActive="active">
                Contact Us
            </a>
        </li>
    </ul>
</header>
<mat-drawer-container
    [class]="mobileHeaderClass"
    [class.mobile-header--nav-open]="mobileNavOpen"
    [hasBackdrop]="true"
>
    <mat-drawer
        class="mobile-nav-drawer"
        #drawer
        mode="over"
        position="start"
        (openedChange)="onMobileNavOpenedChange($event)"
    >
        <nav class="mobile-nav-list" aria-label="Main navigation">
            <button
                type="button"
                class="mobile-nav-row mobile-nav-row--expandable"
                [class.mobile-nav-row--expanded]="profileMenuOpen"
                (click)="toggleProfileMenu()"
                [attr.aria-expanded]="profileMenuOpen"
            >
                <span class="mobile-nav-row__label">My Profile</span>
                <span class="mobile-nav-row__chevron" [class.mobile-nav-row__chevron--open]="profileMenuOpen">
                    <app-icon name="expand_more" />
                </span>
            </button>
            <div class="mobile-nav-submenu" *ngIf="profileMenuOpen && (isLoggedIn$ | async)">
                <div class="mobile-nav-subsection">
                    <a class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/favorite-properties">Favorite List</a>
                    <a *ngIf="auth.isAdmin" class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/admin" routerLinkActive="active">Admin</a>
                    <button type="button" class="mobile-nav-subrow" (click)="logout(); closeMobileNav(drawer)">Log Out</button>
                </div>
            </div>
            <div class="mobile-nav-submenu" *ngIf="profileMenuOpen && (isLoggedOut$ | async)">
                <div class="mobile-nav-subsection">
                    <button type="button" class="mobile-nav-subrow" (click)="openSignIn(); closeMobileNav(drawer)">Sign In</button>
                    <button type="button" class="mobile-nav-subrow" (click)="openSignUp(); closeMobileNav(drawer)">Sign Up</button>
                </div>
            </div>

            <a
                class="mobile-nav-row mobile-nav-row--link"
                (click)="closeMobileNav(drawer)"
                routerLink="/featured-properties"
                routerLinkActive="active"
                [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
            >
                <span class="mobile-nav-row__label">For Sale</span>
            </a>

            <a
                class="mobile-nav-row mobile-nav-row--link"
                (click)="closeMobileNav(drawer)"
                routerLink="/for-rent"
                routerLinkActive="active"
            >
                <span class="mobile-nav-row__label">For Rent</span>
            </a>

            <button
                type="button"
                class="mobile-nav-row mobile-nav-row--expandable"
                [class.mobile-nav-row--expanded]="buyMenuOpen"
                (click)="toggleBuyMenu()"
                [attr.aria-expanded]="buyMenuOpen"
            >
                <span class="mobile-nav-row__label">Buy</span>
                <span class="mobile-nav-row__chevron" [class.mobile-nav-row__chevron--open]="buyMenuOpen">
                    <app-icon name="expand_more" />
                </span>
            </button>
            <div class="mobile-nav-submenu" *ngIf="buyMenuOpen">
                <div class="mobile-nav-subsection">
                    <p class="mobile-nav-subsection__heading">Search listings</p>
                    <a class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/featured-properties">Real Estate Search</a>
                </div>
                <div class="mobile-nav-subsection">
                    <p class="mobile-nav-subsection__heading">Buyer resources</p>
                    <a class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/buyer-guide" routerLinkActive="active">Buyer's Guide</a>
                </div>
            </div>

            <button
                type="button"
                class="mobile-nav-row mobile-nav-row--expandable"
                [class.mobile-nav-row--expanded]="sellMenuOpen"
                (click)="toggleSellMenu()"
                [attr.aria-expanded]="sellMenuOpen"
            >
                <span class="mobile-nav-row__label">Sell</span>
                <span class="mobile-nav-row__chevron" [class.mobile-nav-row__chevron--open]="sellMenuOpen">
                    <app-icon name="expand_more" />
                </span>
            </button>
            <div class="mobile-nav-submenu" *ngIf="sellMenuOpen">
                <div class="mobile-nav-subsection">
                    <p class="mobile-nav-subsection__heading">Home value</p>
                    <a class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/home-estimate-page">What's My Home Worth?</a>
                </div>
                <div class="mobile-nav-subsection">
                    <p class="mobile-nav-subsection__heading">Seller resources</p>
                    <a class="mobile-nav-subrow" (click)="closeMobileNav(drawer)" routerLink="/seller-guide">Seller's Guide</a>
                </div>
            </div>

            <a class="mobile-nav-row mobile-nav-row--link" (click)="closeMobileNav(drawer)" routerLink="/agents">
                <span class="mobile-nav-row__label">Agents</span>
            </a>

            <a class="mobile-nav-row mobile-nav-row--link" (click)="closeMobileNav(drawer)" routerLink="/contact-page">
                <span class="mobile-nav-row__label">Contact Us</span>
            </a>
        </nav>
    </mat-drawer>
    <mat-drawer-content>
        <div class="mobile-toolbar" [class.mobile-toolbar--nav-open]="mobileNavOpen">
            <img
                id="mobile-logo"
                class="mobile-toolbar__logo"
                src="/assets/brand/gabali-logo.png"
                routerLink="/home"
                alt="Gabali Realty logo"
            >
            <button
                type="button"
                id="menu-icon"
                class="mobile-menu-toggle mobile-toolbar__toggle"
                [class.mobile-menu-toggle--open]="mobileNavOpen"
                [attr.aria-expanded]="mobileNavOpen"
                [attr.aria-label]="mobileNavOpen ? 'Close menu' : 'Open menu'"
                (click)="toggleMobileNav(drawer)"
            >
                <span class="mobile-menu-toggle__bar"></span>
                <span class="mobile-menu-toggle__bar"></span>
                <span class="mobile-menu-toggle__bar"></span>
            </button>
        </div>
    </mat-drawer-content>
</mat-drawer-container>
